import { render, staticRenderFns } from "./ObjHistory.vue?vue&type=template&id=9642c6f8&"
import script from "./ObjHistory.vue?vue&type=script&lang=js&"
export * from "./ObjHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports